var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6cm",
    height: "4cm",
    viewBox: "-10 -10 3020 2020",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "French_Flag_by_Adam_Stanislav"
  }, /*#__PURE__*/React.createElement("title", null, "Flag of France, by Adam Stanislav"), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(0%,14%,58%)",
    x: 0,
    y: 0,
    width: 1010,
    height: 2000
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(97%,97%,97%)",
    x: 1000,
    y: 0,
    width: 1010,
    height: 2000
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(93%,16%,22%)",
    x: 2000,
    y: 0,
    width: 1000,
    height: 2000
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "rgb(55%,55%,55%)",
    strokeWidth: 10,
    x: 0,
    y: 0,
    width: 3000,
    height: 2000
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/France.d299627cf04905d30e65be255027ba8f.svg";
export { ForwardRef as ReactComponent };